export enum ColumnTypes {
    ATTRIBUTE_NAME = 'Attribute',
    ATTRIBUTE_DESCRIPTION = 'Attribute Description',
    DATA_TYPE = 'Data Type',
    POSSIBLE_VALUES = 'Possible Values',
    REQUIRED = 'Required',
    DEPRECATED = 'Deprecated',
    ATTRIBUTE_LAST_USAGE_DATE = 'Last Usage Date',
}

export const ColumnWidth = {
    [ColumnTypes.ATTRIBUTE_NAME]: '16rem',
    [ColumnTypes.ATTRIBUTE_DESCRIPTION]: 'calc(80% - 61rem)',
    [ColumnTypes.DATA_TYPE]: '14rem',
    [ColumnTypes.POSSIBLE_VALUES]: '20%',
    [ColumnTypes.REQUIRED]: '9rem',
    [ColumnTypes.DEPRECATED]: '9rem',
    [ColumnTypes.ATTRIBUTE_LAST_USAGE_DATE]: '11rem',
};
